import useAuth from "../hooks/use-auth";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import TextFormField from "@common/components/forms/text-form-field";
import AppButton from "@common/components/app-button";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import useResetPasswordTokenHandler from "../hooks/use-reset-password-token-handler";
import {
    forgotPasswordSchema,
    ForgotPasswordSchemaType
} from "../constants/forgot-password-schema";

const ForgotPasswordForm = () => {
    const {getTokenToResetPassword} = useAuth();
    const navigate = useNavigate();
    const {resendCountdown, handleResendToken: resendToken, setInitialTimer} = useResetPasswordTokenHandler();
    const [hasSentLink, setHasSentLink] = useState(resendCountdown > 0);

    useEffect(() => {
        if (resendCountdown > 0) {
            setHasSentLink(true);
        }
    }, [resendCountdown]);

    const methods = useForm<ForgotPasswordSchemaType>({
        resolver: yupResolver(forgotPasswordSchema),
        defaultValues: {
            email: '',
        },
    });

    const {formState: {isSubmitting}} = methods;

    const handleGetTokenResetPassword = async () => {
        await methods.trigger();

        if (!methods.formState.isValid) {
            return;
        }

        const body = methods.getValues();
        await getTokenToResetPassword(body.email);
        setHasSentLink(true);
        setInitialTimer();
    };

    const handleResendToken = async () => {
        const email = methods.getValues().email;
        if (email) {
            await resendToken(email);
        }
    };

    const handleSubmit = async () => {
        if (hasSentLink) {
            await handleResendToken().catch((err)=>{
                return;
            });
        } else {
            await handleGetTokenResetPassword().catch((err)=>{
                return;
            });
        }
    };

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(handleSubmit)} className="space-y-6">
                <TextFormField
                    name="email"
                    label="Email"
                    placeholder="Email"
                />


                {methods.formState.errors.root && (
                    <div className="text-red-600 text-sm text-center">
                        {methods.formState.errors.root.message}
                    </div>
                )}

                <div className="flex items-center justify-between">
                    <AppButton
                        onClick={() => navigate("/login")}
                        type='button'
                        disabled={isSubmitting}
                        label="Cofnij"
                        className='!rounded-[4rem] !border-none text-primary text-[1rem] h-[40px] font-semibold bg-primary-alt hover:bg-primary-alt/80'/>

                    <AppButton
                        type='submit'
                        loading={isSubmitting}
                        disabled={resendCountdown > 0}
                        label={
                            hasSentLink 
                                ? (resendCountdown > 0 ? `Wyślij ponownie link (${resendCountdown})` : "Wyślij ponownie link")
                                : "Wyślij link"
                        }
                        className='!rounded-[4rem] text-on-primary text-[1rem] h-[40px] font-semibold bg-primary hover:bg-primary/80'/>
                </div>
            </form>
        </FormProvider>
    );
}

export default ForgotPasswordForm
